import React from 'react';

interface PossessionTimesSectionProps {
  usTime: number;
  themTime: number;
  activeTimer: 'US' | 'THEM' | null;
  glowButton: 'US' | 'THEM' | 'NONE' | null;
  formatTime: (t: number) => string;
  onButtonClick: (side: 'US' | 'THEM' | 'NONE') => void;
  disabledButtons?: Partial<Record<'US' | 'THEM' | 'NONE', boolean>>;
}

const PossessionTimesSection: React.FC<PossessionTimesSectionProps> = ({
  usTime,
  themTime,
  activeTimer,
  glowButton,
  formatTime,
  onButtonClick,
  disabledButtons = {},
}) => (
  <div className="z-10">
    <div className="relative text-2xl font-bold text-center">Possession Times</div>
    <div className="relative flex w-full justify-between items-stretch gap-4 z-10 py-5 px-3">
      <div className="flex-1 flex justify-center">
        <div
          className={`w-full font-bold rounded-lg px-3 xs:px-6 py-4 text-center flex flex-col justify-center items-center shadow-lg transition-all
            ${
              glowButton === 'US'
                ? 'multi-glow-border text-black'
                : activeTimer === 'US'
                  ? 'bg-white text-black border-2 border-[#7fe526]'
                  : 'bg-[#7fe526] text-black'
            } ${disabledButtons.US ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
          onClick={() => {
            if (!disabledButtons.US) onButtonClick('US');
          }}
        >
          <div className="text-xl sm:text-2xl">US</div>
          <div className="text-base font-semibold mt-1">{formatTime(usTime).toUpperCase()}</div>
        </div>
      </div>
      <div className="flex-1 flex justify-center">
        <div
          className={`w-full font-bold rounded-lg px-3 xs:px-6 py-4 text-center flex flex-col justify-center items-center shadow-lg transition-all
            ${glowButton === 'NONE' ? 'multi-glow-border none-border text-black' : 'bg-[#22194d] text-white'} ${
              disabledButtons.NONE ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
            }`}
          onClick={() => {
            if (!disabledButtons.NONE) onButtonClick('NONE');
          }}
        >
          <div className="text-xl sm:text-2xl">NONE</div>
        </div>
      </div>
      <div className="flex-1 flex justify-center">
        <div
          className={`w-full font-bold rounded-lg px-3 xs:px-6 py-4 text-center flex flex-col justify-center items-center shadow-lg transition-all
            ${
              glowButton === 'THEM'
                ? 'multi-glow-border them-border text-black'
                : activeTimer === 'THEM'
                  ? 'bg-white text-black border-2 border-[#294e87]'
                  : 'bg-[#294e87] text-white'
            } ${disabledButtons.THEM ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
          onClick={() => {
            if (!disabledButtons.THEM) onButtonClick('THEM');
          }}
        >
          <div className="text-xl sm:text-2xl">THEM</div>
          <div className="text-base font-semibold mt-1">{formatTime(themTime).toUpperCase()}</div>
        </div>
      </div>
    </div>
  </div>
);

export default PossessionTimesSection;
